import { useSelector } from 'react-redux';

import { RootState } from '@stores/store';

export const usePermission = (submoduleId: string = '', allowedRoles: string[] = []) => {
  const userDetails = useSelector((state: RootState) => state?.UserData?.user);
  const modulesDetails = useSelector((state: RootState) => state?.ModulesData.modules);

  let role = userDetails?.role;

  if (submoduleId) {
    const subModule = modulesDetails
      ?.flatMap((module) => module.submodules || [])
      .find((submodule) => submodule.id === submoduleId);

    if (subModule?.hasFullAccess) {
      role = 'ADMIN';
    }
  }

  const isAuthenticated = Boolean(userDetails?.id);
  const isAuthorized = Boolean(isAuthenticated && role && allowedRoles.includes(role));

  return { isAuthorized, role, isAuthenticated, userDetails };
};
